import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const propTypes = {
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  type: PropTypes.string,
  rounded: PropTypes.bool,
}

const defaultProps = {
  disabled: false,
  selected: false,
  type: 'button',
  rounded: false,
}

function BaseButton(props) {
  const {
    children,
    href,
    onClick,
    disabled,
    rounded,
    type,
    className,
    cy,
  } = props
  const isExternalLink = url => /^(http|https):\/\//.test(url || '')

  const disabledClass = disabled ? `opacity-50 cursor-not-allowed` : ''
  const roundedClass = rounded ? `rounded-full` : 'rounded-lg'
  const classes = `inline-block py-3 px-4 sm:px-5 font-semibold border cursor-pointer select-none outline-none ${className} ${disabledClass} ${roundedClass}`

  function handleClick() {
    if (disabled) {
      return
    } else if (onClick) {
      onClick()
    }
  }

  return href ? (
    isExternalLink(href) || (!href && onClick) ? (
      <a href={href} onClick={onClick} className={classes}>
        {children}
      </a>
    ) : (
      <Link to={href} onClick={onClick} className={classes}>
        {children}
      </Link>
    )
  ) : (
    <button
      data-cy={cy}
      disabled={disabled}
      onClick={handleClick}
      className={classes}
      type={type}
    >
      {children}
    </button>
  )
}

BaseButton.propTypes = propTypes
BaseButton.defaultProps = defaultProps

export default BaseButton
